<script>
import { Payment } from '@/enums/Payment'
import CheckoutDetails from './CheckoutDetails.vue'
import CheckoutNextStep from './CheckoutNextStep.vue'

export default {
  components: {
    CheckoutDetails,
    CheckoutNextStep
  },
  props: {
    order: { type: Object },
    nextStep: { type: Function }
  },
  data: () => ({
    price: {},
    error: false,
    hasEmptyBaseData: true,
    selectedPayment: null,
    loadingPrice: true
  }),
  methods: {
    emptyBaseData(baseDataStatus) {
      this.hasEmptyBaseData = baseDataStatus
    },
    profilError(errorState) {
      // override only, when there is no error yet
      if (!this.error) this.error = errorState
    },
    async handlePaymentSelection(event) {
      if (this.price.totalGrossPrice >= 15) return
      this.loadingPrice = true
      await this.$ordersService
        .recalculatePrice({
          orderId: this.order.orderId,
          addPayPalFee: event === Payment.PayPal
        })
        .then(priceResponse => {
          this.price = priceResponse
          this.selectedPayment = event
          this.loadingPrice = false
        })
    },
    // empty, maybe for later use
    handelPaymentCancel(event) {
      return event
    }
  }
}
</script>
<template>
  <div>
    <v-row v-if="error">
      <v-col cols="md-12" class="center-text">
        <v-container fluid>
          <v-row>
            <v-col cols="6" class="mx-auto">
              <v-alert type="error">
                {{ $t('component.checkout.checkoutOpen.loading.error') }}
              </v-alert>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12" md="6">
        <v-card flat>
          <v-card-title>
            <h1 class="headline text-center primary--text">
              {{ $t('component.checkout.checkoutOpen.details.header') }}
            </h1>
          </v-card-title>
          <v-card-text class="pa-0">
            <CheckoutDetails
              :price="price"
              :payment="selectedPayment"
              :loading-price="loadingPrice"
              @emptyBaseData="emptyBaseData"
              @profilError="profilError"/>
          </v-card-text>
          <v-card-text>
            <v-list-item class="pl-0 pr-0">
              <v-list-item-icon class="mr-2">
                <v-icon color="primary" x-large>mdi-information</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                {{ $t('component.checkout.checkoutOpen.check.data') }}
              </v-list-item-content>
            </v-list-item>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card flat>
          <v-card-title>
            <h1 class="headline text-center primary--text">
              {{ $t('component.checkout.checkoutOpen.payment.options') }}
            </h1>
          </v-card-title>
          <v-card-text>
            <CheckoutNextStep
              :price="price"
              :disabled="hasEmptyBaseData"
              :order-id="order.orderId"
              :next-step="nextStep"
              :loading-price="loadingPrice"
              @onPaymentSelected="handlePaymentSelection"
              @onPaymentCancel="handelPaymentCancel"
            /></v-card-text>
          <v-card-text>
            <v-list-item class="pl-0 pr-0">
              <v-list-item-icon class="mr-2">
                <v-icon color="primary" x-large>mdi-information</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <span v-html="$t('component.checkout.checkoutOpen.b2b')"></span>
              </v-list-item-content>
            </v-list-item>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
